<template lang="pug">
  v-row.mt-12.just.align-center.justify-center(
    v-if="viewForm"
  )
    v-col(cols="12" md="6")
      .text-body-1.mb-2 Вот информация о вашем ФИО, которую мы получили от Telegram.
      .text-body-1.mb-4.
        Пожалуйста, скорректируйте её при необходимости, тут должно быть именно ваше ФИО,
        которое будет показываться организациям, при подаче вами заявлений

      api-form(
        v-model="formData"
        :fields="fieldsPersonal"
        :defaultAttrs="{filled: true,rounded: true}"
        :method="saveSettingsPersonal"
        :successCallback="onSuccess"
        :inital="initial"
        :btn-props="{ rounded: true, color: 'success' }"
      )
</template>

<script>
import { isToday } from 'date-fns';

export default {
  name: 'AuthorizeOutside',
  data: () => ({
    viewForm: false,
    formData: {},
    initial: {},
    isLoading: false,
  }),
  computed: {
    // initial() {
    //   if (this.$user.data.info) {
    //     const { info } = this.$user.data;
    //     return {
    //       information_surname: info.surname,
    //       information_first_name: info.first_name,
    //       information_patronymic: info.patronymic,
    //     };
    //   }
    //   return {};
    // },
    redirectRoute() {
      return this.$route.query.redirect || { name: 'Desktop' };
    },
    fieldsPersonal() {
      return [
        {
          text: 'Фамилия',
          value: 'information_surname',
          component: 'v-text-field',

        },
        {
          text: 'Имя',
          value: 'information_first_name',
          component: 'v-text-field',

        },
        {
          text: 'Отчество',
          value: 'information_patronymic',
          component: 'v-text-field',

        },

      ];
    },
  },
  created() {
    this.loginByTelegram();
  },
  methods: {
    saveSettingsPersonal({ data }) {
      return this.$api.users.saveUserSettings(data);
    },
    async onSuccess() {
      localStorage.setItem('isInfoUserSet', true);
      await this.$user.syncUser();
      this.$router.push({ name: 'Desktop' });
    },
    async loginByTelegram() {
      const payload = {
        auth_result: this.$route.hash.split('=')[1],
        role: 5,
      };
      const { data } = await this.$api.auth.telegramAuth(payload);
      if (data) {
        const { access_token: accessToken, refresh_token: refreshToken } = data.data;
        await this.$store.dispatch('auth/INIT_USER', { accessToken, refreshToken });
        const isInfoSet = localStorage.getItem('isInfoUserSet');
        if (this.$user.data.telegram && !isInfoSet) {
          const date = new Date(this.$user.data.telegram.created_at);
          const isNewUser = isToday(date);

          if (isNewUser) {
            const { info } = this.$user.data;
            this.initial = {
              information_surname: info.surname,
              information_first_name: info.first_name,
              information_patronymic: info.patronymic,
            };
            this.viewForm = true;
            return;
          }

          this.$router.push(this.redirectRoute);
          return;
        }
        this.$router.push(this.redirectRoute);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
